import { useState } from 'react';
import qs from 'qs';
import { getOptionByHitsPerPage, getPageSizeDefault } from '../data/pageSizeOptions';

const usePageSize = initialHitsPerPage => {
    const queryParams = qs.parse(window.location.search.slice(1));
    const optionFromUrl = getOptionByHitsPerPage(Number(queryParams.perPage) || initialHitsPerPage);
    const optionDefault = getPageSizeDefault();
    const [pageSize, setPageSize] = useState(optionFromUrl || optionDefault);

    return { pageSize, setPageSize };
};

export default usePageSize;
